import { render, staticRenderFns } from "./TicketDetailsHistory.vue?vue&type=template&id=8a80bc92&scoped=true"
import script from "./TicketDetailsHistory.vue?vue&type=script&lang=js"
export * from "./TicketDetailsHistory.vue?vue&type=script&lang=js"
import style0 from "./TicketDetailsHistory.vue?vue&type=style&index=0&id=8a80bc92&prod&lang=scss&scoped=true"
import style1 from "./TicketDetailsHistory.vue?vue&type=style&index=1&id=8a80bc92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a80bc92",
  null
  
)

export default component.exports